import type { CSSProperties, MouseEvent } from 'react';
import styled from 'styled-components';

import { Flex, VFlex } from '@/components/base';
import PropertyValue from '@/components/Typography/PropertyValue';
import Typo from '@/components/Typography/Typo';
import TicketLabel from '@/features/Commons/Ticket/TicketLabel';
import useColor from '@/hooks/domain/useColor';
import { type FeedbackSentiment, sentimentMap } from '@/types/feedbackConst';

type Props = {
  onClick?: (e: MouseEvent) => void;
  sentiment: FeedbackSentiment;
  text?: string;
  tid: string;
  account_name?: string;
  contact_name?: string;
  style?: CSSProperties;
  index?: string;
  focused?: boolean;
};

const SentimentFeedbackItem = (props: Props) => {
  const { icon, value } = sentimentMap[props.sentiment || 2];
  const color = useColor();
  return (
    <Style
      g={12}
      onClick={props.onClick}
      style={props.style}
      data-feedback-id={props.index}
      focused={props.focused}
      sentiment={props.sentiment}
    >
      <Typo type="body2" weight="m" multilineEllipsis={2} color={color.gray700}>
        {props.text}
      </Typo>
      <PropertyArea a="center" g={8}>
        <TicketLabel type="feedback">{props.tid}</TicketLabel>
        <PropertyValue
          value={
            <Flex a="center" g={8}>
              {icon}
              <Typo type="label3" color={color.gray600}>
                {value}
              </Typo>
            </Flex>
          }
        />
        {props.account_name && (
          <PropertyValue
            value={
              <Typo type="label3" color={color.gray600}>
                {props.account_name}
              </Typo>
            }
          />
        )}
        {props.contact_name && (
          <PropertyValue
            value={
              <Typo type="label3" color={color.gray600}>
                {props.contact_name}
              </Typo>
            }
          />
        )}
      </PropertyArea>
    </Style>
  );
};

type StyleProps = {
  focused?: boolean;
  sentiment: FeedbackSentiment;
};

const Style = styled(VFlex)<StyleProps>`
  padding: 12px 16px;
  border: 1px solid
    ${({ theme, focused }) =>
      focused ? theme.colors.primary100 : theme.colors.gray400};

  cursor: pointer;
  transition: all 0.2s;
  border-radius: 8px;
  transition: all 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.colors.hover};
  }
`;

const PropertyArea = styled(Flex)`
  min-height: 24px;
  flex-wrap: wrap;
`;

export default SentimentFeedbackItem;
